export function PrivacyPolicy() {
  return (
    <div className="privacy-page">
      <div className="privacy-container">
        <header className="privacy-header">
          <h1>Privacy Policy</h1>
          <p className="last-updated">Last updated: September 2026</p>
        </header>

        <section>
          <h2>Your Data Is Your Own</h2>
          <p>
            Critical Stack Ledger does not collect, store, or use your personal information for any purpose beyond operating the application you explicitly requested.
          </p>
          <p>
            We do not:
          </p>
          <ul>
            <li>Sell your data</li>
            <li>Share your data with advertisers</li>
            <li>Use your data for marketing</li>
            <li>Use your data for analytics or tracking</li>
            <li>Profile you or build behavioral models</li>
            <li>Use your data for any purpose other than providing the service you requested</li>
          </ul>
        </section>

        <section>
          <h2>What We Store</h2>
          <p>
            To provide the Critical Stack Ledger service, we store only what is necessary:
          </p>
          <ul>
            <li>Your email address and encrypted password (for authentication only)</li>
            <li>Expense data you enter (merchant, amount, date, category, purpose)</li>
            <li>Receipt images and evidence you upload</li>
            <li>Business information you create</li>
          </ul>
          <p>
            This data belongs to you. You can download, export, or delete it at any time.
          </p>
        </section>

        <section>
          <h2>How We Secure Your Data</h2>
          <p>
            Your data is encrypted in transit (HTTPS) and at rest. We use industry-standard security practices:
          </p>
          <ul>
            <li>TLS encryption for all network communication</li>
            <li>Database encryption provided by Supabase</li>
            <li>Role-based access control for business data</li>
            <li>No unnecessary logging or tracking</li>
          </ul>
        </section>

        <section>
          <h2>Infrastructure Partners</h2>
          <p>
            We use the following services to operate the application:
          </p>
          <ul>
            <li>
              <strong>Supabase</strong> — for secure authentication and database storage
            </li>
            <li>
              <strong>Cloudflare</strong> — for web hosting and file storage
            </li>
          </ul>
          <p>
            These are infrastructure providers, not data brokers. Your data stays encrypted and is never shared with them beyond what is necessary for operation.
          </p>
        </section>

        <section>
          <h2>Data Deletion</h2>
          <p>
            You can delete your account and all associated data at any time. When you delete your account:
          </p>
          <ul>
            <li>All your expenses, receipts, and business information are permanently deleted</li>
            <li>Your authentication credentials are removed</li>
            <li>Deletion takes effect within 30 days</li>
          </ul>
        </section>

        <section>
          <h2>Legal Requests</h2>
          <p>
            If we receive a legal demand for your data (subpoena, warrant, etc.), we will only comply as required by law. We will notify you of any such request unless legally prohibited.
          </p>
        </section>

        <section>
          <h2>Mobile App Permissions</h2>
          <p>
            The iOS app requests access to:
          </p>
          <ul>
            <li><strong>Camera:</strong> To capture receipt photos (optional, only when you choose)</li>
            <li><strong>Photo Library:</strong> To select receipt images (optional, only when you choose)</li>
          </ul>
          <p>
            These permissions are only used when you explicitly request them. We do not access your camera roll or photos without your action.
          </p>
        </section>

        <section>
          <h2>Changes to This Policy</h2>
          <p>
            If we make material changes to this privacy policy, we will notify you. Your continued use of the service after changes means you accept the updated policy.
          </p>
        </section>

        <section>
          <h2>Questions?</h2>
          <p>
            If you have any questions about your privacy or how we handle your data:
          </p>
          <div className="contact-info">
            <p>
              <strong>Email:</strong> support@criticalstackledger.com
            </p>
            <p>
              We will respond to your request within 30 days.
            </p>
          </div>
        </section>

        <footer className="privacy-footer">
          <p>
            © 2026 Critical Stack Ledger. Your data is your own.
          </p>
        </footer>
      </div>
    </div>
  );
}
